import { Link } from 'react-router';
import ClockIcon from '@/assets/icons/clock.svg?react';
import { ROUTES } from '@/shared/config/routes';
import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';
import { useResendSignInLink } from '../hooks/use-resend-sign-in-link';
import type { SignInLinkData } from '../types';

type LinkExpiredViewProps = {
  link: SignInLinkData;
  onSent: (link: SignInLinkData) => void;
};

export function LinkExpiredView({ link, onSent }: LinkExpiredViewProps) {
  const { resendSignInLink, isResending } = useResendSignInLink();

  const sendNew = async () => {
    const outcome = await resendSignInLink(link.id);
    if (outcome.link) onSent(outcome.link);
  };

  return (
    <>
      <span data-enter="">
        <BadgeIcon tone="warn">
          <ClockIcon className="size-5.5" />
        </BadgeIcon>
      </span>
      <div data-enter="" className="flex flex-col gap-2">
        <h1 className="font-semibold text-title-lg">This link has expired</h1>
        <p className="text-muted">
          Sign-in links work once, for 15 minutes. We can send a fresh one to {link.email}.
        </p>
      </div>
      <Button
        data-enter=""
        variant="primary"
        size="lg"
        isBlock
        isLoading={isResending}
        onClick={() => void sendNew()}
      >
        Email me a new link
      </Button>
      <p data-enter="" className="text-meta text-muted">
        <Link to={ROUTES.SIGN_IN} className="font-medium text-ink underline underline-offset-3">
          Back to sign in
        </Link>
      </p>
    </>
  );
}
